var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container wizard"},[_vm._m(0),_c('div',{staticClass:"row content"},[(this.url !== '')?_c('iframe',{attrs:{"src":this.url,"width":"100%","height":"900px"},on:{"load":this.loadIFrame}}):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('h2',[_vm._v("Documento con Firma Digital")])])])
}]

export { render, staticRenderFns }